import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _HeaderLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("rect", { width: 17, height: 4, x: 3.5, y: 3.5, stroke: "currentColor", rx: 1.5 }), _jsx("rect", { width: 17, height: 17, x: 3.5, y: 3.5, stroke: "currentColor", strokeDasharray: "2 2", rx: 1.5 }), _jsx("path", { stroke: "currentColor", d: "M5.5 5.5h2M9.5 5.5H18" })] }) });
}
const HeaderLightCustom = forwardRef(_HeaderLightCustom);
export { HeaderLightCustom };
